import MaterialTable from "@material-table/core";
import _ from "lodash";
import {
  CustomToolTipEditIcon,
  CustomToolTipReport,
  CustomToolTipUrgentOrders,
  CustomToolTipUrgentOrders1,
} from "../../../load-build/utility/tooltip";
import { useState } from "react";
import { useUserInfo } from "../../../common/user-context";
import { log } from "../../../Helper";
import useFilterState from "../../../hooks/useFilterState";
import { GREEN, BLUE, YELLOW, WHITE, RED, theme } from "../utility/constants";
import AvisReportPickUpDialog from "../avisDialog/AvisReportPickUpDialog/AvisReportPickUpDialog";

const AvisMaterialTable = (props) => {
  const providerOrderTable = "AVIS";
  const {
    tableName,
    tableRef,
    columns,
    handleClickOpen,
    setPageNumber,
    tableData,
    handleTableRefresh,
  } = props;

  const { userData } = useUserInfo();
  const [open, setOpen] = useState(false);
  const [selectedMachinesForReporting, setSelectedMachinesForReporting] =
    useState([]);
  const [separatedData, setSeparatedData] = useState([]);

  const onPageChange = (e) => {
    setPageNumber(e);
  };
  const handleClose = (event, reason) => {
    if (reason === undefined) {
      setOpen(false);
    }
  };

  const handleOpen = () => {
    setOpen(true);
  };
  const processDataForReportPickUp = (rowData) => {
    // create the custom object for report pickup.
    // create the list of machines in one build to show in table
    // VIEW is returning the data with "," separated for city, country, arrivalDate, comar with respect to orderPathId

    log("reporting machines rawdata-- ", rowData);
    const orderPaths = rowData.orderPathId;

    let splitArray = [];
    let colorDepartureDates = "";
    let departureDateOption;

    // Determine the departure date and set the color (green for Jdlink, blue for Mainchain, yellow for Avis)
    if (
      null != rowData.departureDateAvis &&
      !_.isEmpty(rowData.departureDateAvis)
    ) {
      departureDateOption = rowData.departureDateAvis;
      colorDepartureDates = WHITE;
    } else if (
      null != rowData.departureDateForwarder &&
      !_.isEmpty(rowData.departureDateForwarder)
    ) {
      departureDateOption = rowData.departureDateForwarder;
      colorDepartureDates = RED;
    }else if (
      null != rowData.departureDateJdlink &&
      !_.isEmpty(rowData.departureDateJdlink)
    ) {
      departureDateOption = rowData.departureDateJdlink;
      colorDepartureDates = GREEN;
    } else if (
      null != rowData.departureDateMainchain &&
      !_.isEmpty(rowData.departureDateMainchain)
    ) {
      departureDateOption = rowData.departureDateMainchain;
      colorDepartureDates = BLUE;
    } else {
      departureDateOption = rowData.avisDate;
    }

    if (orderPaths.includes(",")) {
      let orderPathArray = orderPaths.split(",");

      log("multiple machines in one build, creating the list for table");

      let cityArr = rowData.aggCity.split(",");
      let countryArr = rowData.aggCountry.split(",");
      let arrivalDateArr =
        null != rowData.arrivalDate && !_.isEmpty(rowData.arrivalDate)
          ? rowData.arrivalDate.split(",")
          : []; // this is arrival date for avis only
      let comarArr = rowData.opComar.split(",");
      let contractDaysArr =
        null != rowData.aggContractDays && !_.isEmpty(rowData.aggContractDays)
          ? rowData.aggContractDays.split(",")
          : [];
      let actualArrivalDateMainchainArr =
        null != rowData.actualArrivalDateMainchain &&
        !_.isEmpty(rowData.actualArrivalDateMainchain)
          ? rowData.actualArrivalDateMainchain.split(",")
          : [];
      let actualArrivalDateJdlinkArr =
        null != rowData.actualArrivalDateJdlink &&
        !_.isEmpty(rowData.actualArrivalDateJdlink)
          ? rowData.actualArrivalDateJdlink.split(",")
          : [];
      let actualArrivalDateForwarderArr =
        null != rowData.actualArrivalDateForwarder &&
        !_.isEmpty(rowData.actualArrivalDateForwarder)
          ? rowData.actualArrivalDateForwarder.split(",")
          : [];
      let estimatedArrivalDateAvisArr =
        null != rowData.estimatedArrivalDateAvis &&
        !_.isEmpty(rowData.estimatedArrivalDateAvis)
          ? rowData.estimatedArrivalDateAvis.split(",")
          : [];

      for (let i = 0; i < orderPathArray.length; i++) {
        // array format of city list after split ['69780:PLEVEN', '67212:MONTANA', '95887:UJHARTYAN']

        let city;
        let country;
        let arrivalDate;
        let comar;
        let contractDaysValue;
        let actualArrivalDateMainchain;
        let actualArrivalDateJdlink;
        let actualArrivalDateForwarder;
        let estimatedArrivalDateAvis;
        let estimatedArrivalDateOption;
        let colorArrivalDates = "";

        for (let j = 0; j < cityArr.length; j++) {
          if (cityArr[j].split(":")[0] == orderPathArray[i]) {
            city = cityArr[j].split(":")[1];
            break;
          }
        }

        for (let j = 0; j < countryArr.length; j++) {
          if (countryArr[j].split(":")[0] == orderPathArray[i]) {
            country = countryArr[j].split(":")[1];
            break;
          }
        }

        for (let j = 0; j < arrivalDateArr.length; j++) {
          if (arrivalDateArr[j].split(":")[0] == orderPathArray[i]) {
            arrivalDate = arrivalDateArr[j].split(":")[1];
            break;
          }
        }

        for (let j = 0; j < comarArr.length; j++) {
          if (comarArr[j].split(":")[0] == orderPathArray[i]) {
            comar = comarArr[j].split(":")[1];
            break;
          }
        }

        for (let j = 0; j < contractDaysArr.length; j++) {
          if (contractDaysArr[j].split(":")[0] == orderPathArray[i]) {
            contractDaysValue = contractDaysArr[j].split(":")[1];
            break;
          }
        }

        for (let j = 0; j < actualArrivalDateMainchainArr.length; j++) {
          if (
            actualArrivalDateMainchainArr[j].split(":")[0] == orderPathArray[i]
          ) {
            actualArrivalDateMainchain =
              actualArrivalDateMainchainArr[j].split(":")[1];
            break;
          }
        }

        for (let j = 0; j < actualArrivalDateJdlinkArr.length; j++) {
          if (
            actualArrivalDateJdlinkArr[j].split(":")[0] == orderPathArray[i]
          ) {
            actualArrivalDateJdlink =
              actualArrivalDateJdlinkArr[j].split(":")[1];
            break;
          }
        }
        log("actualArrivalDateForwarderArr", actualArrivalDateForwarderArr);
        for (let j = 0; j < actualArrivalDateForwarderArr.length; j++) {
          if (actualArrivalDateForwarderArr[j].split(":")[0] == orderPathArray[i]) {
            actualArrivalDateForwarder = actualArrivalDateForwarderArr[j].split(":")[1];
            break;
          }
        }

        for (let j = 0; j < estimatedArrivalDateAvisArr.length; j++) {
          if (
            estimatedArrivalDateAvisArr[j].split(":")[0] == orderPathArray[i]
          ) {
            estimatedArrivalDateAvis =
              estimatedArrivalDateAvisArr[j].split(":")[1];
            break;
          }
        }

        // Determine the arrival date and set the color (white for reported, green for Jdlink, blue for Mainchain, yellow for estimated Avis)
        if (
          _.isEmpty(estimatedArrivalDateOption) &&
          null !== arrivalDate &&
          !_.isEmpty(arrivalDate)
        ) {
          estimatedArrivalDateOption = arrivalDate;
          colorArrivalDates = WHITE;
        }
        if (
          _.isEmpty(estimatedArrivalDateOption) &&
          null !== actualArrivalDateForwarder &&
          !_.isEmpty(actualArrivalDateForwarder)
        ) {
          estimatedArrivalDateOption = actualArrivalDateForwarder;
          colorArrivalDates = RED;
        }
        if (
          _.isEmpty(estimatedArrivalDateOption) &&
          null !== actualArrivalDateJdlink &&
          !_.isEmpty(actualArrivalDateJdlink)
        ) {
          estimatedArrivalDateOption = actualArrivalDateJdlink;
          colorArrivalDates = GREEN;
        }

        if (
          _.isEmpty(estimatedArrivalDateOption) &&
          null !== actualArrivalDateMainchain &&
          !_.isEmpty(actualArrivalDateMainchain)
        ) {
          estimatedArrivalDateOption = actualArrivalDateMainchain;
          colorArrivalDates = BLUE;
        }

        if (
          _.isEmpty(estimatedArrivalDateOption) &&
          null !== estimatedArrivalDateAvis &&
          !_.isEmpty(estimatedArrivalDateAvis)
        ) {
          estimatedArrivalDateOption = estimatedArrivalDateAvis;
          colorArrivalDates = YELLOW;
        }

        const orderPathData = {
          arrivalDate:
            null != arrivalDate && !_.isEmpty(arrivalDate) ? arrivalDate : null,
          asn: rowData.asn,
          avisDate: rowData.avisDate,
          build: rowData.build,
          buildId: rowData.buildId,
          // if departure date is already reported then that or else take the PlannedLoadingDate if available
          departureDate: departureDateOption,
          estimatedArrivalDate: estimatedArrivalDateOption,
          from: rowData.from,
          loadbuild: rowData.loadbuild,
          orderPathId: orderPathArray[i],
          shpOrder: rowData.shpOrder,
          toCity: city,
          toCountry: country,
          zcomar: comar,
          zproviderId: rowData.zproviderId,
          colorArrivalDate: colorArrivalDates,
          colorDepartureDate: colorDepartureDates,
          finalArrivalDate: "",
          contractDays: contractDaysValue,
        };

        // if ArrivalDate is reported for any one machine in build, take that date for that machine and for other machines take estimated arrival date if available
        let date =
          null != orderPathData.arrivalDate &&
          !_.isEmpty(orderPathData.arrivalDate)
            ? orderPathData.arrivalDate
            : null != orderPathData.estimatedArrivalDate &&
                !_.isEmpty(orderPathData.estimatedArrivalDate)
              ? orderPathData.estimatedArrivalDate
              : null;

        orderPathData.finalArrivalDate =
          null != date && !_.isEmpty(date) ? date.slice(0, 10) : null;

        splitArray.push(orderPathData);
      }
      setSeparatedData(splitArray);
    } else {
      log("single order path found in build");

      let estimatedArrivalDateOption = "";
      let colorArrivalDates = "";

      // Determine the arrival date and set the color (white for reported, green for Jdlink, blue for Mainchain, yellow for estimated Avis)
      if (
        _.isEmpty(estimatedArrivalDateOption) &&
        null !== rowData.arrivalDate &&
        !_.isEmpty(rowData.arrivalDate)
      ) {
        if (rowData.arrivalDate.includes(":")) {
        estimatedArrivalDateOption = rowData.arrivalDate.split(":")[1];
        } else {
          estimatedArrivalDateOption = rowData.arrivalDate;
        }
        colorArrivalDates = WHITE;
      }
      if (
        _.isEmpty(estimatedArrivalDateOption) &&
        null !== rowData.actualArrivalDateForwarder &&
        !_.isEmpty(rowData.actualArrivalDateForwarder)
      ) {
        if (rowData.actualArrivalDateForwarder.includes(":")) {
        estimatedArrivalDateOption = rowData.actualArrivalDateForwarder.split(":")[1];
        } else {
          estimatedArrivalDateOption = rowData.actualArrivalDateForwarder;
        }
        colorArrivalDates = RED;
      }
      if (
        _.isEmpty(estimatedArrivalDateOption) &&
        null !== rowData.actualArrivalDateJdlink &&
        !_.isEmpty(rowData.actualArrivalDateJdlink)
      ) {
        if (rowData.actualArrivalDateJdlink.includes(":")) {
        estimatedArrivalDateOption =
          rowData.actualArrivalDateJdlink.split(":")[1];
        } else {
          estimatedArrivalDateOption = rowData.actualArrivalDateJdlink;
        }
        colorArrivalDates = GREEN;
      }
      if (
        _.isEmpty(estimatedArrivalDateOption) &&
        null !== rowData.actualArrivalDateMainchain &&
        !_.isEmpty(rowData.actualArrivalDateMainchain)
      ) {
        if (rowData.actualArrivalDateMainchain.includes(":")) {
        estimatedArrivalDateOption =
          rowData.actualArrivalDateMainchain.split(":")[1];
        } else {
          estimatedArrivalDateOption = rowData.actualArrivalDateMainchain;
        }
        colorArrivalDates = BLUE;
      }
      if (
        _.isEmpty(estimatedArrivalDateOption) &&
        null !== rowData.estimatedArrivalDateAvis &&
        !_.isEmpty(rowData.estimatedArrivalDateAvis)
      ) {
        if (rowData.estimatedArrivalDateAvis.includes(":")) {
        estimatedArrivalDateOption =
          rowData.estimatedArrivalDateAvis.split(":")[1];
        } else {
          estimatedArrivalDateOption = rowData.estimatedArrivalDateAvis;
        }
        colorArrivalDates = YELLOW;
      }

      const orderPathData = {
        arrivalDate: rowData.arrivalDate,
        asn: rowData.asn,
        avisDate: rowData.avisDate,
        build: rowData.build,
        buildId: rowData.buildId,
        departureDate: departureDateOption,
        estimatedArrivalDate: estimatedArrivalDateOption,
        from: rowData.from,
        loadbuild: rowData.loadbuild,
        orderPathId: rowData.orderPathId,
        shpOrder: rowData.shpOrder,
        toCity: rowData.toCity,
        toCountry: rowData.toCountry,
        zcomar: rowData.zcomar,
        colorArrivalDate: colorArrivalDates,
        colorDepartureDate: colorDepartureDates,
        zproviderId: rowData.zproviderId,
        finalArrivalDate: "",
        contractDays: rowData.contractDays,
      };

      log("final orderpath data is ", orderPathData);

      // if ArrivalDate is reported for any one machine in build, take that date for that machine and for other machines take estimated arrival date if available
      let date =
        null != orderPathData.arrivalDate &&
        !_.isEmpty(orderPathData.arrivalDate)
          ? orderPathData.arrivalDate.split(":")[1]
          : null != orderPathData.estimatedArrivalDate &&
              !_.isEmpty(orderPathData.estimatedArrivalDate)
            ? orderPathData.estimatedArrivalDate
            : null;

      orderPathData.finalArrivalDate =
        null != date && !_.isEmpty(date) ? date.slice(0, 10) : null;

      splitArray.push(orderPathData);
      setSeparatedData(splitArray);
    }
    log("reporting machines-- ", separatedData);
  };

  const [columnsWithFilter, handleFilterChange] = useFilterState(
    tableName,
    columns
  );

  return (
    <div id="avis-page-table">
      <MaterialTable
        tableRef={tableRef}
        localization={{
          body: {
            emptyDataSourceMessage: (
              <h6 className="left-[45%] absolute top-[40%] text-center">
                No records to display
              </h6>
            ),
          },
          pagination: {
            labelRowsPerPage: "Orders Per Page:",
            labelDisplayedRows: "{from}-{to} of {count}", // Fix this line
            labelRowsSelect: "orders",
          },
        }}
        options={{
          rowStyle: {
            fontSize: 10,
          },
          
          selection: false,
          search: false,
          paging: true,
          showTitle: false,
          grouping: true,
          pageSize: 100,
          filtering: true,
          maxBodyHeight: 600,
          headerStyle: {
            backgroundColor: "#367c2b",
            fontWeight: "400",
            color: "white",
            position: "sticky",
            top: 0,
            zIndex: 10,
            textAlign: "center",
          },
          tableContainerStyle: {
            maxHeight: 600,
            overflow: "auto",
          },
          pageSizeOptions: [100, 500, 1000],
          actionsColumnIndex: -1,
          actionsCellStyle: {
            textAlign: "center",
            width: 120,
            padding: "4px",
          },
          actionsHeaderStyle: {
            textAlign: "center",
            width: 120,
          },
          filterCellStyle: {
            flex: 1
          },
        }}
        onChangePage={(e) => onPageChange(e)}
        title={providerOrderTable}
        columns={columnsWithFilter.map((col, index) => {
          if (
            col.tableData?.filterValue == "" ||
            col.tableData?.filterValue == null ||
            col.tableData?.filterValue == undefined
          ) {
            let colWithoutDefaultFilter = _.omit(
              col,
              "defaultFilter",
              "tableData.filterValue"
            );
            return colWithoutDefaultFilter;
          } else {
            return {
              ...col,
              defaultFilter: col.tableData?.filterValue,
            };
          }
        })}
        data={tableData}
        onFilterChange={(filters) => {
          // Create a map of current filters for quick lookup
          const filterMap = new Map();
          filters.forEach((filter) => {
            filterMap.set(filter.column.tableData.id, filter.value);
          });

          // Iterate over all columns to ensure each one is checked if the value is present in the filter map
          columns.forEach((col, columnId) => {
            const newValue = filterMap.get(columnId) || ""; // Default to empty string if not found

            // Update the filter state for each column
            handleFilterChange(columnId, newValue);
          });
        }}
        actions={[
          (rowData) => {
            // Disable edit load build for orders which are not load builded but shipped
            if (rowData.buildId !== 0) {
              return {
                icon: () => <CustomToolTipEditIcon title={"Edit Load Build"} />,
                onClick: (event, rowData) => {
                  handleClickOpen(rowData);
                },
              };
            }
            return null; // Return null if the condition is not met
          },
          (rowData) => ({
            icon: () => <CustomToolTipReport title={"Report Pick Up"} />,
            onClick: (event, rowData) => {
              handleOpen(rowData);
              processDataForReportPickUp(rowData);
              setSelectedMachinesForReporting([rowData]);
            },
          }),
        ]}
      />
      <AvisReportPickUpDialog
        open={open}
        handleClose={handleClose}
        selectedMachinesForReporting={separatedData}
        getTableData={handleTableRefresh}
        userData={userData}
      />
      </div>
  );
};

export default AvisMaterialTable;
